module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('span', {
    staticClass: "todo-count"
  }, [_c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.remaining)
    }
  }), _vm._v(" " + _vm._s(_vm.pluralize('item', _vm.remaining)) + " left\n\t\t\t\t")]), _vm._v(" "), _c('ul', {
    staticClass: "filters"
  }, [_c('li', [_c('a', {
    class: {
      selected: _vm.filter == 'all'
    },
    attrs: {
      "href": "#/all"
    }
  }, [_vm._v("All")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      selected: _vm.filter == 'active'
    },
    attrs: {
      "href": "#/active"
    }
  }, [_vm._v("Active")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      selected: _vm.filter == 'completed'
    },
    attrs: {
      "href": "#/completed"
    }
  }, [_vm._v("Completed")])])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.todos.length > _vm.remaining),
      expression: "todos.length > remaining"
    }],
    staticClass: "clear-completed",
    on: {
      "click": _vm.removeCompleted
    }
  }, [_vm._v("\n      Clear completed\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cf5bd386!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToDoFooter.vue
// module id = 33
// module chunks = 1